import { EidosBaseList } from "./eidos-base-list.model";

export class EidosCompany extends EidosBaseList {

   constructor(item?: any) {
    super();

    if (item) {
      this.id = item.CompanyId;
      this.code = item.CompanyCode;
      this.description = item.Company;
    }
  }
}
